import { AGENT_BY_ID } from '../config/competition'
import { compactMoney, pct, signedCompactMoney, signedPct } from '../core/format'
import type { LeaderRow } from '../core/types'
import { HouseTag, VendorTag } from './primitives/Bits'
import { AgentAvatar } from './primitives/Media'
import { Panel } from './primitives/Panel'
import { Standby } from './primitives/Standby'

function Move({ row }: { row: LeaderRow }) {
  const delta = row.prevRank - row.rank
  if (delta === 0) return <span className="lb__move is-flat">=</span>
  const up = delta > 0
  return (
    <span className={`lb__move ${up ? 'is-up' : 'is-down'}`} title={`${up ? 'up' : 'down'} ${Math.abs(delta)}`}>
      {up ? '\u25B2' : '\u25BC'}
      {Math.abs(delta)}
    </span>
  )
}

export function Leaderboard({ rows, standby }: { rows: LeaderRow[]; standby: boolean }) {
  if (standby) {
    return (
      <Panel title="LEADERBOARD" note={<span className="u-label">RANKED BY EQUITY</span>}>
        <Standby note="Rank, ROI, win rate, drawdown and Sharpe per agent." />
      </Panel>
    )
  }

  return (
    <Panel title="LEADERBOARD" note={<span className="u-label">RANKED BY EQUITY</span>} flush>
      <table className="lb">
        <thead>
          <tr>
            <th scope="col" className="lb__rank">
              #
            </th>
            <th scope="col">AGENT</th>
            <th scope="col">HOUSE</th>
            <th scope="col" className="num">
              EQUITY
            </th>
            <th scope="col" className="num">
              P&L
            </th>
            <th scope="col" className="num">
              ROI
            </th>
            <th scope="col" className="num">
              WIN
            </th>
            <th scope="col" className="num">
              FILLS
            </th>
            <th scope="col" className="num">
              MAX DD
            </th>
            <th scope="col" className="num">
              SHARPE
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const a = AGENT_BY_ID[r.agentId]
            if (!a) return null
            return (
              <tr key={r.agentId} className={r.rank === 1 ? 'is-leader' : ''}>
                <td className="lb__rank">
                  <span className="lb__pos u-num">{r.rank}</span>
                  <Move row={r} />
                </td>
                <td>
                  <span className="lb__agent">
                    <AgentAvatar agentId={a.id} size={20} />
                    <span className="lb__name">{a.name}</span>
                    <VendorTag vendor={a.vendor} />
                  </span>
                </td>
                <td>
                  <HouseTag house={a.house} />
                </td>
                <td className="num u-num">{compactMoney(r.equity)}</td>
                <td className={`num u-num ${r.pnl >= 0 ? 'u-up' : 'u-down'}`}>
                  {signedCompactMoney(r.pnl)}
                </td>
                <td className={`num u-num ${r.roiPct >= 0 ? 'u-up' : 'u-down'}`}>
                  {signedPct(r.roiPct, 1)}
                </td>
                <td className="num u-num">{pct(r.winRatePct, 0)}</td>
                <td className="num u-num">{r.tradeCount}</td>
                <td className="num u-num u-down">{pct(r.maxDrawdownPct, 1)}</td>
                <td className="num u-num">{r.sharpe.toFixed(2)}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </Panel>
  )
}
